import { cn } from "@/lib/utils";
import { CheckIcon } from "lucide-react";
import Link from "next/link";
import { useState } from "react";

export default function PricingSection() {
  const [isYearly, setIsYearly] = useState(false);

  return (
    <section className="pricing-section">
      <div className="w-full flex justify-center">
        <div className="w-full max-w-[1250px] py-16 lg:pt-32 lg:pb-40 px-9 flex flex-col gap-3 md:gap-4 justify-center items-center">
          <h1 className="max-w-[548px] text-center text-[32px] md:text-[56px] leading-[32px] md:leading-[58px] text-[#0D2A4C] tracking-tighter font-semibold">
            Transparent Pricing for any Team Size
          </h1>
          <div className="bg-[#F8F9FA] border border-[#0D2A4C08] rounded-[100px] p-0.5 flex cursor-pointer">
            <div
              role="button"
              className={cn(
                "py-3 lg:py-[15px] px-6 lg:px-[22px] rounded-[100px] bg-transparent",
                !isYearly && "bg-white border border-[#0D2A4C0D]"
              )}
              onClick={() => setIsYearly(false)}
            >
              <p
                className={cn(
                  "text-sm lg:text-[16px] leading-3.5 tracking-tight text-[#0D2A4C99] font-medium",
                  !isYearly && "text-[#0D2A4C] font-semibold"
                )}
              >
                Monthly
              </p>
            </div>
            <div
              role="button"
              className={cn(
                "py-3 lg:py-[15px] px-6 lg:px-[22px] rounded-[100px] bg-transparent",
                isYearly && "bg-white border border-[#0D2A4C0D]"
              )}
              onClick={() => setIsYearly(true)}
            >
              <p
                className={cn(
                  "text-sm lg:text-[16px] leading-3.5 tracking-tight text-[#0D2A4C99] font-medium",
                  isYearly && "text-[#0D2A4C] font-semibold"
                )}
              >
                Yearly
              </p>
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-8 w-full mt-6 lg:mt-0">
            <div className="lg:min-h-[565px] w-full bg-[#F8F9FA] px-6 py-8 flex flex-col rounded-[12px] border border-[#0D2A4C08]">
              <div className="flex flex-col">
                <p className="font-semibold text-lg leading-5 text-[#0D2A4C]">
                  Professional
                </p>
                <div className="flex items-end pt-0.5">
                  <p className="text-[#0D2A4C] text-[56px] leading-[56px] font-semibold tracking-tight">
                    ${isYearly ? "77" : "97"}
                  </p>
                  <p className="text-[#0D2A4C99] text-xl leading-[36px] font-semibold tracking-tight -translate-x-0.5">
                    /month
                  </p>
                </div>
                {isYearly && (
                  <span className="text-xs italic font-medium text-[#0D2A4C99] pl-2">
                    *Billed anually
                  </span>
                )}
                <p className="text-sm lg:text-[16px] leading-[22px] font-medium text-[#0D2A4C99] pt-2 lg:pt-2.5 tracking-tight">
                  Perfect for solo founders and closers who want to start
                  booking calls right away.
                </p>
                <Link
                  href={
                    isYearly
                      ? "https://app.listkit.io/login?plan=professionalYearlyV2&screen=signup"
                      : "https://app.listkit.io/login?plan=professionalV2&screen=signup"
                  }
                  className="mt-5 bg-white w-full text-center hover:bg-[#2A8DFF]/5 active:outline-1 active:!outline-white active:bg-white rounded-[100px] py-[11px] px-[18px] md:py-[15px] md:px-[22px] cursor-pointer"
                >
                  <p className="text-[#0D2A4C] text-sm md:text-[16px] font-semibold tracking-tight">
                    Start With Professional
                  </p>
                </Link>
                <div className="flex flex-col mt-8 lg:mt-14 gap-[15px] lg:gap-[18px]">
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      2,000 Triple-Verified Email Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Unlimited Email Verifier Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      100 Mobile Number Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      CRM & Sending Tool Integrations
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Unlimited Users
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:min-h-[565px] lg:translate-y-[50px] w-full bg-[#F8F9FA] px-6 py-8 flex flex-col overflow-hidden relative rounded-[12px] border border-[#0D2A4C08]">
              <div className="bg-[#2A8DFF] w-[304px] py-2.5 lg:py-[15px] px-[22px] absolute -right-[100px] lg:-right-[90px] top-5 lg:top-4 text-center rotate-[30deg]">
                <p className="text-white text-sm lg:text-[16px] leading-3 lg:leading-3.5 tracking-tight font-semibold">
                  Most Popular
                </p>
              </div>
              <div className="flex flex-col">
                <p className="font-semibold text-lg leading-5 text-[#0D2A4C]">
                  Scale
                </p>
                <div className="flex items-end pt-0.5">
                  <p className="text-[#0D2A4C] text-[56px] leading-[56px] font-semibold tracking-tight">
                    ${isYearly ? "237" : "297"}
                  </p>
                  <p className="text-[#0D2A4C99] text-xl leading-[36px] font-semibold tracking-tight -translate-x-0.5">
                    /month
                  </p>
                </div>
                {isYearly && (
                  <span className="text-xs italic font-medium text-[#0D2A4C99] pl-2">
                    *Billed anually
                  </span>
                )}
                <p className="text-sm lg:text-[16px] leading-[22px] font-medium text-[#0D2A4C99] pt-2 lg:pt-2.5 tracking-tight">
                  Ideal for growing teams and agencies that need more data and
                  expert support.
                </p>
                <Link
                  href={
                    isYearly
                      ? "https://app.listkit.io/login?plan=scaleYearlyV2&screen=signup"
                      : "https://app.listkit.io/login?plan=scaleV2&screen=signup"
                  }
                  className="mt-5 bg-[#2A8DFF] text-center w-full hover:bg-[#2A8DFF]/90 active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] rounded-[100px] py-[11px] px-[18px] md:py-[15px] md:px-[22px] cursor-pointer"
                >
                  <p className="text-white text-sm md:text-[16px] font-semibold tracking-tight">
                    Start With Scale
                  </p>
                </Link>
                <div className="flex flex-col mt-8 lg:mt-14 gap-[15px] lg:gap-[18px]">
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Everything in Professional
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      8,000 Triple-Verified Email Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      400 Mobile Number Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Unlimited Intent Topics & Filters
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      1-on-1 Cold Email Coaching Call
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Cold Email Program ($497 value)
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lg:min-h-[565px] w-full bg-[#F8F9FA] px-6 py-8 flex flex-col overflow-hidden relative rounded-[12px] border border-[#0D2A4C08]">
              <div className="flex flex-col">
                <p className="font-semibold text-lg leading-5 text-[#0D2A4C]">
                  Enterprise
                </p>
                <div className="flex items-end pt-0.5">
                  <p className="text-[#0D2A4C] text-[56px] leading-[56px] font-semibold tracking-tight">
                    CUSTOM
                  </p>
                </div>
                <p className="text-sm lg:text-[16px] leading-[22px] font-medium text-[#0D2A4C99] pt-2 lg:pt-2.5 tracking-tight">
                  Designed for high-volume teams that want automation,
                  integrations, and DFY setup.
                </p>
                <Link
                  href="/demo-form"
                  className="mt-5 bg-white text-center w-full hover:bg-[#2A8DFF]/5 active:outline-1 active:!outline-white active:bg-white rounded-[100px] py-[11px] px-[18px] md:py-[15px] md:px-[22px] cursor-pointer"
                >
                  <p className="text-[#0D2A4C] text-sm md:text-[16px] font-semibold tracking-tight">
                    Contact Sales
                  </p>
                </Link>
                <div className="flex flex-col mt-8 lg:mt-14 gap-[15px] lg:gap-[18px]">
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Everything in Scale
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Bulk Credits
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      DFY CRM Workflows & Integrations
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Custom Intent Data Topics
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      DFY Cold Email Setup
                    </p>
                  </div>
                  <div className="flex gap-1 items-center">
                    <CheckIcon className="size-4 lg:size-[20px] text-[#2A8DFF]" />
                    <p className="text-sm lg:text-[16px] text-[#0D2A4C99] leading-[22px] tracking-tight font-medium">
                      Dedicated Account Manager
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
